import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Como funciona o investimento na Karpa Investimentos?",
    answer: "Você investe seu capital conosco e nossa equipe de traders profissionais opera em WIN e WDO. Acompanhe todos os resultados em tempo real diretamente na sua conta da corretora."
  },
  {
    question: "Qual o valor mínimo para investir?",
    answer: "Entre em contato conosco para conhecer as opções de investimento disponíveis e encontrar a que melhor se adequa ao seu perfil."
  },
  {
    question: "Qual a rentabilidade esperada?",
    answer: "A rentabilidade varia de acordo com as condições de mercado e estratégias aplicadas. Nossa equipe trabalha para buscar os melhores resultados de forma consistente e sustentável."
  },
  {
    question: "Como acompanho meus investimentos?",
    answer: "Nós da Karpa Investimentos não captamos recursos, todo o investimento e operações são realizadas em sua conta da corretora."
  },
  {
    question: "Posso resgatar meu capital a qualquer momento?",
    answer: "Sim! Seu capital está a todo momento sobre seu controle, sem vinculo e prazo de conosco."
  },
  {
    question: "Quem são os traders que operam meu capital?",
    answer: "Nossa equipe é composta por traders profissionais com histórico comprovado e experiência em operar WIN e WDO com estratégias consistentes."
  },
  {
    question: "Há garantia de retorno?",
    answer: "Investimentos no mercado financeiro envolvem riscos. Trabalhamos com gestão profissional para buscar os melhores resultados, mas não há garantia de retorno."
  }
];

const FAQSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-foreground">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-muted-foreground">
            Tire suas dúvidas sobre nosso processo e regulamento
          </p>
        </div>
        
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-card rounded-lg border border-border shadow-card hover:shadow-elegant transition-all duration-300"
            >
              <AccordionTrigger className="px-6 py-4 text-left font-semibold text-foreground hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;